import { Button, Card } from '@repo/shadcn';

import { SectionContainer } from '@components/shared';
import {
    HeaderBreadcrumb,
    SectionDataTable,
    SectionTitle,
} from '@components/ui';

import { Route } from '../../../../constants';
import { ProductSectionFilters } from '../../product-section-filters.component';
import { strengthListColumns } from './strength-list.column';
import { useStrengthList } from './strength-list.hook';

export const StrengthList = () => {
    const {
        data,
        isLoading,
        isError,
        error,
        isFetching,
        handleCreateStrength,
    } = useStrengthList();

    return (
        <SectionContainer isError={isError} isLoading={isLoading} error={error}>
            <Card className={'space-y-4 p-4'}>
                <div className={'flex items-start justify-between'}>
                    <div className={'space-y-2'}>
                        <HeaderBreadcrumb
                            items={[
                                { label: 'Products', href: Route.PRODUCTS },
                                { label: 'Strengths' },
                            ]}
                        />
                        <SectionTitle>Strength List</SectionTitle>
                    </div>
                    <Button onClick={handleCreateStrength} type={'button'}>
                        Create New Strength
                    </Button>
                </div>
                <ProductSectionFilters />
                <SectionDataTable
                    columns={strengthListColumns}
                    data={data}
                    isLoading={isLoading || isFetching}
                />
            </Card>
        </SectionContainer>
    );
};

StrengthList.displayName = 'StrengthList';
